import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConstantsService } from './services/constants.service';
import { environment } from '../environments/environment';
import { runtimeConfig } from './config/runtime-config';
import { LogoComponent } from './components/logo/logo.component';
import { BannerComponent } from './components/banner/banner.component';
import { AppStartupService } from './services/app-startup.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LogoComponent, BannerComponent, RouterOutlet]
})
export class AppComponent {
  readonly title = 'phone-support-website';
  readonly environment = { ...environment, appName: runtimeConfig.appName };
  readonly logoBrand = computed(() => {
    const siteBrand = this.startup.siteBrand();
    const routePath = this.startup.routePath().toLowerCase();
    const isAccountDeletionRoute = ['delete', 'landing', 'success', 'failure']
      .some(segment => routePath.includes(segment));

    return siteBrand.toLowerCase() === 'thrive' && isAccountDeletionRoute
      ? 'starkey'
      : siteBrand;
  });

  constructor(
    public readonly startup: AppStartupService,
    public readonly constantsService: ConstantsService
  ) {
    startup.initialize();
  }
}


